export enum TableFilterTypeEnum {
  /**
   * On a click on this filter type, a date range picker is displayed.
   */
  DATE = 'date',

  MULTI_CHOICE = 'multi-choice',
}
